
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ios",
      function () {
        return require("private-next-pages/ios.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ios"])
      });
    }
  